<template>
	<AppCard :title="getString('x_service_status', [userStore.deliveryWord])" :button-text="getString('save')" @button-click="$emit('save-status')">
		<template v-slot:body>
			<AppList :items="statusItems">
				<template #dropdown>
					<div v-show="link" class="col-12 centered">
						<AppQrImage name="delivery" :value="link" with-download-button />
						<div class="link-container" @click="clickCopyLink" @mouseenter="activeClickToCopyCloud=true" @mouseleave="activeClickToCopyCloud=false">
							<p>{{ link }}</p>
							<input class="invisible" type="text" ref="current-link" :value="link">
							<AppInPlaceCloud :active="activeClickToCopyCloud">
								<div class="centered pl-20 pr-20">
									<p v-html="linkCloudMessage"></p>
								</div>
							</AppInPlaceCloud>
						</div>
					</div>
					<div v-show="!link" class="col-12 centered">
						<p>{{getString('set_link_to_view')}}</p>
					</div>
				</template>
			</AppList>
		</template>
	</AppCard>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";
import AppList from "@/shared/components/AppList.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppQrImage from "@/shared/components/AppQrImage.vue";

import {useLanguageStore, useScriptStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let scriptStore = useScriptStore();
		return {getString: languageStore.getString, userStore, loadScript: scriptStore.loadScript}
	},
	name: "DeliveryStatusCard",
	emits: ['save-status'],
	components: {AppCard, AppList, AppButton, AppQrImage, AppInPlaceCloud, AppChevronIcon},
	data() {
		return {
			activeDownloadQrCloud: false,
			activeClickToCopyCloud: false,
			closeDownloadCloudListener: null,
			linkCloudMessage: this.getString('copy'),
			loadedQrLibrary: false,
			qrLoadTimeout: null,
			currQr: null,
			downloadLink: null,
			activeQrSection: false,
		}
	},
	computed: {
		link() {
			if(this.userStore && this.userStore.currBusinessId && this.userStore.businesses && this.userStore.currBusiness) {
				let business = this.userStore.currBusiness;
				let link = null;
				if(business.link) {
					link = business.link + URL_DOMAIN + "/";
				}
				if(link) {
					return link.startsWith('https://') || link.startsWith('http://') ? link : "https://" + link;
				}
				return null;
			}
			return "";
		},
		statusItems() {
			return [
				{
					title: this.getString('enabled_service_x', [this.userStore.deliveryWord]),
					switch: true,
					active: this.activeDelivery,
					explain: this.getString('delivery_x_subtitle', [this.userStore.deliveryWord]),
					callback: (newStatus) => {
						this.userStore.currBusiness.delivery = newStatus;
					}
				},
				{
					title: this.getString('qr_and_link'),
					chevronItem: true,
					dropdownSlot: 'dropdown',
					active: false,
					explain: this.getString('x_service_explain', [this.userStore.deliveryWord, this.userStore.menuWord]),
				}
			]
		},
		activeDelivery() {
			return this.userStore.currBusiness ? this.userStore.currBusiness.delivery : false;
		},
	},
	methods: {
		clickCaption(item) {
			if(item.dropdownSlot) { item.active = !item.active; }
		},
		clickCopyLink() {
			let copyText = this.$refs['current-link'];
			copyText.select();
			copyText.setSelectionRange(0, 99999);
			navigator.clipboard.writeText(copyText.value);
			this.linkCloudMessage = this.getString('copied');
			setTimeout(()=>{
				this.linkCloudMessage = this.getString('copy');
			}, 1500);
		},
	},
}
</script>

<style lang="scss" scoped>
.extra-text {
	width: 100%;
	p {
		font-size: 14px;
		color: #9B9B9B;
	}
}
.row-clickable {
	cursor: pointer;

	.chevron-container {
		height: 35px;
		display: flex;
		align-items: center;
	}
	.list-item-title {
		width: calc(100% - 20px);
		@media (max-width: 560px) {
			font-size: 14px;
		}
		@media (max-width: 400px) {
			font-size: 12px;
		}
	}
}

.link-container {
	@include centered;
	margin-top: 10px;
	position: relative;
	cursor: pointer;

	> p {
		@include noSelect;
	}
}
input.invisible {
	position: absolute;
	z-index: -1;
	opacity: 0;
	height: 0;
	width: 0;
}
</style>